import type {PermissionsRecordType} from '../permissions';

export const userPermissions = {
  readUser: {
    actionId: 'READ',
    resourceId: 'USER',
    scopes: [],
  },
  readUserLoginHistory: {
    actionId: 'READ_LOGIN_HISTORY',
    resourceId: 'USER',
    scopes: [],
  },
  createUser: {
    actionId: 'CREATE',
    resourceId: 'USER',
    scopes: [],
  },
  updateUser: {
    actionId: 'UPDATE',
    resourceId: 'USER',
    scopes: [],
  },
  blockUser: {
    actionId: 'BLOCK',
    resourceId: 'USER',
    scopes: [],
  },
  unblockUser: {
    actionId: 'UNBLOCK',
    resourceId: 'USER',
    scopes: [],
  },
  selectUsersInCalendar: {
    actionId: 'SELECT_USERS_IN_CALENDAR',
    resourceId: 'USER',
    scopes: [],
  },
  selectUsersInKanban: {
    actionId: 'SELECT_USERS_IN_KANBAN',
    resourceId: 'USER',
    scopes: [],
  },
  setKanbanSettings: {
    actionId: 'SET_KANBAN_SETTINGS',
    resourceId: 'USER',
    scopes: [],
  },
} satisfies PermissionsRecordType;
